function EraserIcon(props)
{
    return(
        <svg className={props.class} style={{'transform':'scale(1.3)',"marginTop":'.4rem'}} viewBox="-5.0 -10.0 110.0 135.0">
 <path d="m86.148 35.484-9.1016-9.1016-36.125 36.125 12.398 12.398 32.828-32.828c0.87891-0.87891 1.3672-2.0508 1.3672-3.2969s-0.48438-2.4141-1.3672-3.293z"/>
 <path d="m74.836 24.172-9.1016-9.1016c-1.8164-1.8203-4.7773-1.8164-6.5898 0l-32.828 32.828 12.398 12.398z"/>
 <path d="m78.91 83.168h-33.855l6.0586-6.0586-27-27-10.258 10.258c-1.8164 1.8164-1.8164 4.7734 0 6.5898l18.879 18.879c0.14453 0.14453 0.3125 0.25781 0.50391 0.33594 0.1875 0.078125 0.39062 0.12109 0.60156 0.12109h45.074c0.86328 0 1.5625-0.69922 1.5625-1.5625s-0.69922-1.5625-1.5625-1.5625z"/></svg>
    )
}

export default EraserIcon